import { useToast } from '@chakra-ui/react';
import AdditionalDataFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/card/cardData/AdditionalDataFormUI';
import CardDataFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/card/cardData/CardDataFormUI';
import CardFeesFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/card/cardData/CardFeesFormUI';
import MainCardDataFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/card/cardData/MainCardDataFormUI';
import RenewalDataFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/card/cardData/RenewalDataFormUI';
import ReplacementDataFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/card/cardData/ReplacementDataFormUI';
import CommissionDataTableHandler from '@Modules/cardManagementSystem/cardholder/containers/mixedHandlers/cardData/card/cardData/dataTable/commission/CommissionDataTableHandler';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import RiskManagementMixedHandler from './dataTable/onlineRiskManagement/RiskManagementMixedHandler';
import PeriodicFeesDataTableHandler from './dataTable/periodicFees/PeriodicFeesDataTableHandler';
import ReplacementFeesDataTableHandler from './dataTable/replacementFees/ReplacementFeesDataTableHandler';
import { additionalDataFormMetaObj } from './formMeta/additionalData/AdditionalDataFormMeta';
import cardDataFormMeta from './formMeta/CardDataFormMeta';
import cardFeesFormMeta from './formMeta/CardFeesFormMeta';
import mainCardDataFormMeta from './formMeta/MainCardDataFormMeta';
import renewalDataFormMeta from './formMeta/RenewDataFormMeta';
import replacementDataFormMeta from './formMeta/ReplacementDataFormMeta';

const tabHeaders = [
  'Données\u{202F}\u{202F}Carte',
  'Données\u{202F}\u{202F}Additionnelles',
  'Risque\u{202F}\u{202F}En\u{202F}\u{202F}Ligne',
  'Commission',
  'Donnée\u{202F}\u{202F}Remplacement',
  'Donnée\u{202F}\u{202F}Renouvel.',
  'Frais\u{202F}\u{202F}Carte',
  'Frais\u{202F}\u{202F}Remplacement',
  'Frais\u{202F}\u{202F}Périodiques\u{202F}\u{202F}Divers',
];

const CardDataMixedHandler = () => {
  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = [''];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve('data'), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  const tabContents = React.useMemo(
    () => [
      <CardDataFormUI
        meta={cardDataFormMeta}
        isLoading={isLoading}
      />,
      <AdditionalDataFormUI
        meta={additionalDataFormMetaObj}
        isLoading={isLoading}
      />,
      <RiskManagementMixedHandler />,
      <CommissionDataTableHandler/>,
      <ReplacementDataFormUI
        meta={replacementDataFormMeta}
        isLoading={isLoading}
      />,
      <RenewalDataFormUI
        meta={renewalDataFormMeta}
        isLoading={isLoading}
      />,
      <CardFeesFormUI
        meta={cardFeesFormMeta}
        isLoading={isLoading}
      />,
      <ReplacementFeesDataTableHandler />,
      <PeriodicFeesDataTableHandler />
    ],
    [isLoading, isSubmitting]
  );

  return (
    <>
      <MainCardDataFormUI
        meta={mainCardDataFormMeta}
        onSubmit={onSubmit}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
      />

      <CustomTabs
        tabHeaders={tabHeaders}
        tabContents={tabContents}
        isLazy={false}
      />
    </>
  );
};

export default CardDataMixedHandler;
